import { RestClient } from '@/api/rest-client'
import { PrintedDocument } from '@/api/model/printed-document'

export class PrintedDocumentClient extends RestClient<PrintedDocument> {
    collectionName = 'printed_documents'
    parseData = PrintedDocument.fromData
}
